module.exports = __webpack_public_path__ + "media/images/lb/908-61bea9314ddd1787b16102ceb388c7b9.svg";